import {
    useCallback,
    useContext,
    createContext
} from 'react';

import { decrypt } from '../helpers/cryptography';

import { capsDocsService } from '../api/capsDocsService';
import CAPS from '../constants/caps';

const CapsDocsContext = createContext({});

export const CapsDocsProvider = ({ children }) => {
    const getAllDocuments = useCallback(async (idUsuario, capsUrl) => {
        try {
            const response = await capsDocsService.getAllDocs(idUsuario, capsUrl);
    
            return response;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const getDocumentById = useCallback(async (id, capsUrl) => {
        try {
            const response = await capsDocsService.getDoc(id, capsUrl);
    
            const decryptedResponse = {
                ...response,
                nomeEmissor: response.nomeEmissor ? decrypt(response.nomeEmissor) : '',
                nomeUsuario: response.nomeUsuario ? decrypt(response.nomeUsuario) : '',
                documento: response.documento ? decrypt(response.documento) : '',
                unidade: response.unidade ? decrypt(response.unidade) : '',
                endereco: response.endereco ? decrypt(response.endereco) : '',
            }
    
            return decryptedResponse;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const updateDocument = useCallback(async (id, data, capsUrl) => {
        try {
            const response = await capsDocsService.update(id, data, capsUrl);
    
            return response;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const createDocument = useCallback(async (data, capsUrl) => {
        try {
            const response = await capsDocsService.create(data, capsUrl);

            if (!response.ok) {
                throw new Error('Ocorreu um erro inesperado');
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    const docEmptyValues = {
        idUsuario: '',
        dataEmissao: '',
        tipoDocumento: '',
        nomeEmissor: '',
        status: '',
        nomeUsuario: '',
        documento: '',
        dataAtendimento: '',
        inicioAtendimento: '',
        terminoAtendimento: '',
        finalidade: '',
        unidade: '',
        tempoAtestado: '',
        cid: '',
        endereco: '',
        medicamentoSimples: [],
        medicamentoEspecial: [],
        hash: '',
    }

    const capsInfo = {
        capsCasaDoLargo:{
            unidade: 'CAPS Martha e Dr. Jacinto',
            endereco: 'Travessa Nossa Senhora de Fátima, 76 - Largo da Batalha - Niterói - RJ',
            telefone: '(21) 97031-4469',
        },
        capsHerbertDeSouza: {
            unidade: 'CAPS Herbert de Souza',
            endereco: 'Rua Clotilde de Oliveira Rodrigues, 42 - Fonseca, Niterói - RJ ',
            telefone: '(21) 97030-5896',
        },
        capsiMonteiroLobato: {
            unidade: CAPS.CNES_3708330,
            endereco: 'Avenida Almirante Ary Parreiras, 649 - Vital Brasil, Niterói - RJ',
            telefone: '(21) 97026-9151',
        },
        capsAlameda: {
            unidade: 'CAPS AD III Alcenir Veras',
            endereco: 'Rua Dr. Fróes da Cruz, 22 - Centro, Niterói - RJ',
            telefone: '(21) 97023-1678',
        },
    }

    return (
        <CapsDocsContext.Provider
         value={{
            getAllDocuments,
            getDocumentById,
            createDocument,
            updateDocument,
            docEmptyValues,
            capsInfo
         }}
        >
            {children}
        </CapsDocsContext.Provider>
    );
}

export const useCapsDocs = () => useContext(CapsDocsContext);